// Skill icon registry — maps backend skill codes (class.skill_name) to icon URLs.
// Icons live in /public/assets/skills/{class}/{name}.png (64x64 PNG, MU Online style).

const BASE = '/assets/skills';

// Map: skill code -> public asset URL
export const SKILL_ICONS: Record<string, string> = {
  // ---- Warrior ----
  'warrior.power_slash':           `${BASE}/warrior/power_slash.png`,
  'warrior.death_stab':            `${BASE}/warrior/death_stab.png`,
  'warrior.crescent_moon_slash':   `${BASE}/warrior/crescent_moon_slash.png`,
  'warrior.strike_of_destruction': `${BASE}/warrior/strike_of_destruction.png`,
  'warrior.twisting_slash':        `${BASE}/warrior/twisting_slash.png`,
  'warrior.rageful_blow':          `${BASE}/warrior/rageful_blow.png`,
  'warrior.bloodlust':             `${BASE}/warrior/bloodlust.png`,
  'warrior.earthquake':            `${BASE}/warrior/earthquake.png`,
  'warrior.defense_stance':        `${BASE}/warrior/defense_stance.png`,
  'warrior.greater_fortitude':     `${BASE}/warrior/greater_fortitude.png`,
  'warrior.iron_will':             `${BASE}/warrior/iron_will.png`,
  'warrior.last_stand':            `${BASE}/warrior/last_stand.png`,
  'warrior.dragons_wrath':         `${BASE}/warrior/dragons_wrath.png`,
  'warrior.heavens_pillar':        `${BASE}/warrior/heavens_pillar.png`,

  // ---- Wizard ----
  'wizard.fire_ball':      `${BASE}/wizard/fire_ball.png`,
  'wizard.fire_slash':     `${BASE}/wizard/fire_slash.png`,
  'wizard.meteor_strike':  `${BASE}/wizard/meteor_strike.png`,
  'wizard.inferno':        `${BASE}/wizard/inferno.png`,
  'wizard.ice_bolt':       `${BASE}/wizard/ice_bolt.png`,
  'wizard.ice_storm':      `${BASE}/wizard/ice_storm.png`,
  'wizard.frozen_tomb':    `${BASE}/wizard/frozen_tomb.png`,
  'wizard.glacier':        `${BASE}/wizard/glacier.png`,
  'wizard.mana_shield':    `${BASE}/wizard/mana_shield.png`,
  'wizard.teleport':       `${BASE}/wizard/teleport.png`,
  'wizard.evil_spirit':    `${BASE}/wizard/evil_spirit.png`,
  'wizard.soul_barrier':   `${BASE}/wizard/soul_barrier.png`,
  'wizard.nova':           `${BASE}/wizard/nova.png`,
  'wizard.time_stop':      `${BASE}/wizard/time_stop.png`,

  // ---- Archer ----
  'archer.triple_shot':       `${BASE}/archer/triple_shot.png`,
  'archer.penetration':       `${BASE}/archer/penetration.png`,
  'archer.bone_spirit':       `${BASE}/archer/bone_spirit.png`,
  'archer.one_shot_one_kill': `${BASE}/archer/one_shot_one_kill.png`,
  'archer.multi_shot':        `${BASE}/archer/multi_shot.png`,
  'archer.ice_arrow':         `${BASE}/archer/ice_arrow.png`,
  'archer.rain_of_arrows':    `${BASE}/archer/rain_of_arrows.png`,
  'archer.storm_of_arrows':   `${BASE}/archer/storm_of_arrows.png`,
  'archer.heal':              `${BASE}/archer/heal.png`,
  'archer.greater_defense':   `${BASE}/archer/greater_defense.png`,
  'archer.greater_damage':    `${BASE}/archer/greater_damage.png`,
  'archer.summon_goddess':    `${BASE}/archer/summon_goddess.png`,
  'archer.phoenix_arrow':     `${BASE}/archer/phoenix_arrow.png`,
  'archer.hawk_eye':          `${BASE}/archer/hawk_eye.png`,
};

// Per-class fallback (uses the generic crest icons in the sheet).
const CLASS_FALLBACK: Record<string, string> = {
  warrior: `${BASE}/warrior/warrior_crest.png`,
  wizard:  `${BASE}/wizard/wizard_crest.png`,
  archer:  `${BASE}/archer/archer_crest.png`,
};

/**
 * Resolve an icon URL for a skill.
 * @param code  Backend skill code (e.g. "warrior.power_slash").
 * @param klass Optional class for fallback when code missing.
 */
export function getSkillIcon(code: string | undefined | null, klass?: string): string | undefined {
  if (code && SKILL_ICONS[code]) return SKILL_ICONS[code];
  if (klass && CLASS_FALLBACK[klass]) return CLASS_FALLBACK[klass];
  return undefined;
}
